import * as kyc from './kyc'
import * as common from './common'

export default {
  kyc,
  common
}
